// src/components/BottomNavigation.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  DocumentTextIcon,
  CubeIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  DocumentTextIcon as DocumentTextIconSolid,
  CubeIcon as CubeIconSolid,
  InformationCircleIcon as InformationCircleIconSolid,
} from '@heroicons/react/24/solid';

const BottomNavigation = () => {
  const location = useLocation();

  // ナビゲーションアイテム
  const navItems = [
    {
      name: 'ホーム',
      path: '/',
      icon: <HomeIcon className="h-6 w-6" />,
      activeIcon: <HomeIconSolid className="h-6 w-6" />,
    },
    {
      name: '提案',
      path: '/proposals',
      icon: <DocumentTextIcon className="h-6 w-6" />,
      activeIcon: <DocumentTextIconSolid className="h-6 w-6" />,
    },
    {
      name: 'コイン',
      path: '/tokens',
      icon: <CubeIcon className="h-6 w-6" />,
      activeIcon: <CubeIconSolid className="h-6 w-6" />,
    },
    {
      name: '概要',
      path: '/about',
      icon: <InformationCircleIcon className="h-6 w-6" />,
      activeIcon: <InformationCircleIconSolid className="h-6 w-6" />,
    },
  ];

  // パス一致チェック（子パスも含める）
  const isActive = path => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div className="sm:hidden fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 z-10">
      <div className="grid grid-cols-4">
        {navItems.map(item => (
          <Link
            key={item.path}
            to={item.path}
            className={`flex flex-col items-center justify-center py-2 text-xs ${
              isActive(item.path)
                ? 'text-blue-600 dark:text-blue-400'
                : 'text-gray-500 dark:text-gray-400'
            }`}
          >
            {isActive(item.path) ? item.activeIcon : item.icon}
            <span className="mt-1">{item.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BottomNavigation;
